// src/app/demoMode.ts
const DEMO_KEY = "daex_demo_mode";

export const isDemoMode = (): boolean => {
  if (import.meta.env.VITE_DEMO_MODE === "true") return true;
  return localStorage.getItem(DEMO_KEY) === "true";
};

export const enableDemoMode = () => {
  localStorage.setItem(DEMO_KEY, "true");
};

export const disableDemoMode = () => {
  localStorage.removeItem(DEMO_KEY);
};
